const LABELS = {
  widget_viewed: "Widget viewed", subscription_started: "Form started", subscription_completed: "Subscribed",
  ai_continue_clicked: "AI continue clicked", ai_connection_successful: "AI account connected",
  ai_assessment_started: "AI assessment started", ai_assessment_completed: "AI assessment completed",
};

export function FunnelCards({ data }) {
  if (!data) return <div className="h-28 animate-pulse rounded-xl bg-secondary" />;
  const steps = data.steps;
  const base = steps[0].count || 0;
  return (
    <div className="space-y-4" data-testid="students-funnel">
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {[["Students (all time)", data.totals.students, "students-total"], [`New · last ${data.days}d`, data.totals.new_in_range, "students-new"],
          ["AI connected", data.totals.ai_connected, "students-ai-connected"], ["AI connection rate", `${data.totals.ai_connection_rate}%`, "students-ai-rate"]].map(([l, v, t]) => (
          <div key={t} className="rounded-xl border bg-card p-4">
            <div className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground">{l}</div>
            <div className="mt-1 font-serif text-3xl font-semibold" data-testid={t}>{v}</div>
          </div>
        ))}
      </div>
      <div className="rounded-xl border bg-card p-4">
        <div className="mb-3 text-[11px] font-mono uppercase tracking-widest text-muted-foreground">Funnel · last {data.days} days</div>
        {data.ai_kinds && (
          <div className="mb-3 flex flex-wrap gap-x-5 gap-y-1 text-xs text-muted-foreground" data-testid="funnel-ai-kinds">
            <span>AI continue · <b className="text-foreground">{data.ai_kinds.continue_new}</b> new students · <b className="text-foreground">{data.ai_kinds.continue_returning}</b> returning</span>
            <span>AI connected · <b className="text-foreground">{data.ai_kinds.connected_first}</b> first-time · <b className="text-foreground">{data.ai_kinds.connected_repeat}</b> repeat</span>
          </div>
        )}
        <ol className="grid gap-2 lg:grid-cols-7">
          {steps.map((s, i) => {
            const prev = i ? steps[i - 1].count : s.count;
            const conv = prev ? Math.round((s.count / prev) * 100) : 0;
            const width = base ? Math.max(4, Math.round((s.count / base) * 100)) : 4;
            return (
              <li key={s.event} className="rounded-lg border bg-background p-3" data-testid={`funnel-${s.event}`}>
                <div className="text-xs text-muted-foreground">{LABELS[s.event]}</div>
                <div className="mt-0.5 text-xl font-semibold">{s.count}{s.unique_sessions != null && <span className="ml-1 text-xs font-normal text-muted-foreground">· {s.unique_sessions} sessions</span>}</div>
                <div className="mt-2 h-1.5 w-full rounded-full bg-secondary"><div className="h-1.5 rounded-full bg-slate-900 transition-[width]" style={{ width: `${width}%` }} /></div>
                {i > 0 && <div className="mt-1 text-[11px] text-muted-foreground">{conv}% of previous</div>}
              </li>
            );
          })}
        </ol>
      </div>
      <div className="grid gap-3 lg:grid-cols-2">
        <div className="rounded-xl border bg-card p-4">
          <div className="mb-2 text-[11px] font-mono uppercase tracking-widest text-muted-foreground">Top exams</div>
          {data.by_exam.length === 0 ? <p className="text-sm text-muted-foreground">No subscribers yet.</p> :
            <ul className="space-y-1 text-sm">{data.by_exam.map((e) => <li key={e.exam} className="flex justify-between"><span>{e.exam}</span><span className="font-mono">{e.n}</span></li>)}</ul>}
        </div>
        <div className="rounded-xl border bg-card p-4">
          <div className="mb-2 text-[11px] font-mono uppercase tracking-widest text-muted-foreground">Top source pages</div>
          {data.by_page.length === 0 ? <p className="text-sm text-muted-foreground">No subscribers yet.</p> :
            <ul className="space-y-1 text-sm">{data.by_page.map((p) => <li key={p.page_url || "none"} className="flex justify-between gap-3"><span className="truncate">{p.page_url || "(direct)"}</span><span className="font-mono">{p.n}</span></li>)}</ul>}
        </div>
      </div>
    </div>
  );
}
